<template>
  <div>
    <Rectangle style="margin: 24px 0 17px;" name="流程意见" />
    <!-- <TipsLabel tip="总条数统计：" :count="pageObj.total" /> -->
    <Table :show-pagination="true" :page="pageObj" @setcurrentpage="setCurPage"
           align-type="center" :tableProp="tableProp" 
           :isSection="false" :tableData="tableData" 
    >
    </Table>
  </div>
</template>

<script>
import { getWorkflowList } from '@/http/usercenter'
import vFilter from "@/utif/utif.js";
export default {
  name: 'WorkflowTable',
  props: {
    businessId: String
  },
  data() {
    return {
      pageObj: {
        total: 0,
        currentPage: 1,
        size: 10
      },
      tableProp: [
        {
          code: "taskNodeName",
          label: "节点名称",
        },
        {
          code: "taskResultShow",
          label: "意见结果",
        },
        {
          code: "takeByName",
          label: "处理人",
        },
        {
          code: "taskRemark",
          label: "意见详情",
        },
        {
          code: "updateTime",
          label: "处理时间",
        },
      ],
      tableData: [],
    }
  },
  methods: {
    setCurPage(val) {
      this.pageObj.currentPage = val
      this.getList()
    },
    async getList() {
      const req = {
        businessId: this.businessId,
        page: this.pageObj.currentPage,
        pageSize: this.pageObj.size,
      }
      const resp = await getWorkflowList(req)
      if ( resp.ret == 0) {
        this.pageObj.total = resp.data.totalElements
        this.tableData = resp.data.content
        this.tableData.forEach(item => {
          Object.assign(item, { taskResultShow: vFilter.getSpResult(item.taskResult) || item.taskResult})
        })
      }
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>

</style>